// src/components/FaceMatch.js
import { useEffect, useRef } from "react";
import incode from "../services/incode"; // Asegúrate de que la ruta sea correcta

const FaceMatch = ({ session, onSuccess, onError, liveness, userExists }) => {
  const containerRef = useRef();

  useEffect(() => {
    if (containerRef.current && session) {
      incode.renderFaceMatch(containerRef.current, {
        onSuccess,
        onError,
        token: session, // Usa session.token
        liveness,
        userExists,
      });
    }
  }, [onSuccess, onError, session, liveness, userExists]);

  return <div ref={containerRef}></div>;
};

export default FaceMatch;
